import React from 'react';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
    root: {
        padding: '2px 4px',
        margin: 8,
        display: 'flex',
        alignItems: 'center',
        maxWidth: 800,
        width: "95%"
    },
    input: {
        marginLeft: 8,
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        width: 1,
        height: 28,
        margin: 4,
    }
});

function noOp() { }

export default function SearchBox({ placeholder = "Enter an address...", onInput = noOp }) {
    const classes = useStyles();

    return (
        <Paper className={classes.root} elevation={3}>
            <InputBase className={classes.input} placeholder={placeholder} onChange={e => onInput(e.target.value)} />
            <IconButton className={classes.iconButton} aria-label="Search">
                <SearchIcon />
            </IconButton>
        </Paper>
    );
}